(() => {
  class OrderlabsController {
    constructor($rootScope, $interval, $scope, $timeout, $log, $window, $state, toastr, Auth, ngDialog, Orders, Pharmacy, Notifications, Utils, Dosespot, Constants, MedicationService, Tracking, $sce) {
      'ngInject';

      Object.assign(this, {
        $rootScope,
        $scope,
        $timeout,
        $log,
        $window,
        $state,
        $interval,
        toastr,
        ngDialog,
        Orders,
        Pharmacy,
        Notifications,
        Utils,
        Dosespot,
        Constants,
        MedicationService,
        Tracking,
        $sce,
        currentUser: Auth.profile,
        polls: {}
      });
      $scope.$on('tab:selected:orderlabs', this.init.bind(this));
    }

    $onInit() {
      this.init();
    }

    init() {
      if (this.visit.flags.slv) {
        this.doctor_stage = 2;
      } else {
        this.doctor_stage = 1;
      }

      this.sendLabsOk = false;
      this.labsApprovedOk = false;
      this.reviewLabResultsTask = this.Orders.getTaskByType(this.Constants.VisitTasks.ReviewLabResults, this.Orders.current, this.doctor_stage);
      this.getOrderLabs();
      this.getQRCode();
    }

    disableOrderLab() {
      /*
      return (!this.slvCheckedOk() ||
        this.Orders.current.admin_status == this.Constants.AdminStatuses.LabOrderSent.NumericValue ||
        this.Orders.current.admin_status == this.Constants.AdminStatuses.LabResultsReceived.NumericValue ||
        this.Orders.current.admin_status == this.Constants.AdminStatuses.MedicinePrescribed.NumericValue ||
        this.Orders.current.admin_status == this.Constants.AdminStatuses.RemoteRxCreated.NumericValue ||
        this.Orders.current.admin_status == this.Constants.AdminStatuses.RemoteRxSent.NumericValue ||
        this.Orders.current.admin_status == this.Constants.AdminStatuses.Complete.NumericValue);
      */
      var orderLabsTask = this.Orders.getTaskByType(this.Constants.VisitTasks.OrderLabs, this.Orders.current, this.doctor_stage);
      return !this.slvCheckedOk() || orderLabsTask.status == this.Constants.VisitStatuses.Approved;
    }

    disableApproveLab() {
      var orderLabsTask = this.Orders.getTaskByType(this.Constants.VisitTasks.OrderLabs, this.Orders.current, this.doctor_stage);
      this.reviewLabResultsTask = this.Orders.getTaskByType(this.Constants.VisitTasks.ReviewLabResults, this.Orders.current, this.doctor_stage);

      if (this.reviewLabResultsTask) {
        return orderLabsTask.status != this.Constants.VisitStatuses.Approved || this.reviewLabResultsTask.status == this.Constants.VisitStatuses.Approved;
      } else {
        return true;
      }
    }

    sendOrderLab() {
      var this2 = this;

      this.$window.onbeforeunload = () => {//return stayMessage;
      };

      this2.completinglab = true;
      this2.Orders.sendOrderLab(this2.visit.id).then(({
        data
      }) => {
        this2.Orders.getOne(this2.visit.id).then(({
          data
        }) => {
          this2.visit = data;
          this2.sendLabsOk = true;
          this2.toastr.success('Lab Order was sent.');
          this2.$rootScope.$broadcast('visit:refresh');
        });
      }).catch(err => {
        if (err.status === 409) {
          this2.toastr.error('Error: ' + err.data.message.summary);
        } else {
          this2.toastr.error('Error sending lab order: ' + err.status + ' - ' + err.message);
        }
      }).finally(() => {
        this2.completinglab = false; // Remove the event listener to detect window closure.

        this.$window.onbeforeunload = () => {};
      });
    }

    getQRCode() {
      this.qrData = '';
      const {
        id,
        test_kit
      } = this.visit;

      if (id && test_kit && test_kit.id) {
        this.Orders.getOrderTestKitsQR(id).then(res => {
          this.qrData = res.data;
        }).catch(err => {
          console.error(err);
        });
      }
    }

    createQRCode() {
      const {
        id,
        test_kit
      } = this.visit;

      if (id && test_kit && test_kit.id) {
        this.Orders.createOrderTestKitsQR(id).then(res => {
          this.toastr.success('QR code generated successfully.');
          this.getQRCode();
        }).catch(err => {
          this.toastr.error('Error generating QR code: ' + JSON.stringify(err));
        });
      }
    }

    openQrModal() {
      if ($("#modalQr").hasClass("active")) {
        $("#modalQr").removeClass("active");
      } else {
        $("#modalQr").addClass("active");
      }
    }

    printQr() {
      let windowObject = window.open('', 'PrintWindow', 'width=600,height=400,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes'),
          qrHtml = "<html> <head> <title> QR Code </title> </head> <body onload='window.print();'> <img src='data:image/png;base64, " + this.qrData + "'/></body></html>";
      windowObject.document.writeln(qrHtml);
      windowObject.document.close();
      windowObject.focus();
    }
    /*
        openPDF(fileURL) {
          if (fileURL) {
            this.$window.open(fileURL);
          }
        }
    */


    openPDF(labOrder) {
      if (labOrder.lab && labOrder.lab.result_set && labOrder.fileURL) {
        this.$window.open(labOrder.fileURL);
      }
    }

    getOrderLabs() {
      this.labOrders = [];
      this.visit.lab_orders.forEach(labOrder => {
        if (labOrder.lab.result_set) {
          this.Orders.getOrderLab(this.visit.user.id, labOrder.lab.result_set.id).then(({
            data
          }) => {
            var file = new Blob([data], {
              type: 'application/pdf'
            });
            var fileURL = URL.createObjectURL(file);
            labOrder.fileURL = fileURL;
            labOrder.status = labOrder.lab.result_set.order_status;
            this.labOrders.unshift(labOrder); //this.fileURL = fileURL;
            //this.pdfContent = this.$sce.trustAsResourceUrl(fileURL);
            //this.$window.open(fileURL);
          }).catch(err => {}).finally(() => {});
        } else {
          labOrder.fileURL = null;
          labOrder.status = "sent";
          this.labOrders.push(labOrder);
        }
      }); // COMMENTED FOR BOOTS

      /*
      this.Orders.getScanwellResultsByOrderId(this.visit.id)
      .then(({ data }) => {
         this.scanwellResults = [ data ];
        // console.log("this.scanwellResults: ", this.scanwellResults);
      })
      .catch((err) => {
         this.scanwellResults = [];
         // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
        // if (err && err.data && err.data.error_message) {
        //   this.toastr.error(err.data.error_message);
        // } else {
        //   this.toastr.error(this.Notifications.generic.failure);
        // }
       });
      */
    }

    getLabsApproved() {
      //const payload = 3 ;
      var this2 = this;
      var reviewLabResultsTask = this.Orders.getTaskByType(this.Constants.VisitTasks.ReviewLabResults, this.Orders.current, this.doctor_stage); //this.Orders.updateTask(this.visit.order_lines[0].stages[1].tasks[0].id, payload)

      this.Orders.updateTask(reviewLabResultsTask.id, this.Constants.VisitStatuses.Approved).then(() => {
        this2.labsApprovedOk = true;
        this2.toastr.success('Lab results were approved.');
        this2.$rootScope.$broadcast('visit:refresh');
      }).catch(err => {
        this2.toastr.error('Error: ' + err.data.message.summary);
        /*
        if (err.status == 403) {
          this.errorMessage = this.Notifications.orders.locked;
        } else {
          this.errorMessage = this.Notifications.orders.photos.failed;
        }
        */
      });
    }

    slvCheckedOk() {
      const {
        visit
      } = this;
      const {
        TASKS: VisitTasks,
        STATUS: VisitStatus
      } = this.Orders; // If there is not SLV task required

      if (!visit.flags.slv) return true; // If there is SLV task required
      // Make sure video task is approved before allowing completion

      if (visit.flags.slv) {
        const {
          status: slvTaskStatus
        } = visit.getTask(VisitTasks.SMART_LIVE_VIDEO);

        if (slvTaskStatus === VisitStatus.OPEN || slvTaskStatus === VisitStatus.REJECTED) {
          return false;
        }
      }

      return true;
    }

    requiresAction() {
      return false;
    }

    openPhotoGalleryScanwell(index = 0, image_uri) {
      this.photos = [];
      var photo = {
        file_id: 0,
        image_uri: image_uri
      };
      this.photos.push(photo);
      this.ngDialog.open({
        templateUrl: 'app/components/gallery/gallery.html',
        className: 'ngdialog-theme-default photo-dialog',
        controller: 'GalleryController',
        controllerAs: 'gallery',
        resolve: {
          files: () => this.photos,
          data: () => {
            return {
              index,
              requiresAction: this.requiresAction.bind(this)
            };
          }
        }
      });
    }

  }

  OrderlabsController.$inject = ["$rootScope", "$interval", "$scope", "$timeout", "$log", "$window", "$state", "toastr", "Auth", "ngDialog", "Orders", "Pharmacy", "Notifications", "Utils", "Dosespot", "Constants", "MedicationService", "Tracking", "$sce"];
  angular.module('pims').component('visitOrderlabs', {
    templateUrl: 'app/views/visits/detail/sections/orderlabs/orderlabs.html',
    controller: OrderlabsController,
    bindings: {
      visit: '=',
      parent: '=',
      patient: '='
    }
  });
})();
